import React from 'react'
import LinkedItemPreview from './LinkedItemPreview'

type Props = {
  lesson: { title?: string | null; category?: string | null }
  onRemoveLesson?: () => void
}

const LessonPreview: React.FunctionComponent<Props> = ({ lesson, onRemoveLesson }) => (
  <LinkedItemPreview
    title={lesson.title ?? undefined}
    iconCategory={lesson.category}
    onRemove={onRemoveLesson}
    removeAriaLabel="remove-lesson"
  />
)

export default LessonPreview
